import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import QuestionIcon from 'assets/svg/question-icon-red.svg';
import { RedTextButton } from 'components/buttons/RedTextButton';

const Container = styled(RedTextButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;

  &:hover {
    opacity: 0.7;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

interface Props {
  onClick: () => void;
}

const HelpButton = ({ onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <Container onClick={onClick}>
      <Icon src={QuestionIcon} />
      {t('help')}
    </Container>
  );
};

export default HelpButton;
